import { render } from "./TrainPage.vue?vue&type=template&id=1a5aec29"
import script from "./TrainPage.vue?vue&type=script&lang=js"
export * from "./TrainPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__